/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uuidv4 } from '../../../../shared/utils';

// Component
import { Input } from '@maxmilhas/hangar-components-atomic/public';

export const RadioGroup = ({ options, title, onChange, value, ...rest }) => {
  const [selected, setSelected] = useState(null);

  const optionIsString = option => typeof option === 'string';
  const getOptionValue = option =>
    optionIsString(option) ? option : option.value;
  const getOptionLabel = option =>
    optionIsString(option) ? option : option.label;

  const handleChecked = option => {
    const opt = getOptionValue(option);
    setSelected(opt);
  };

  const checkIfIsChecked = option => {
    const opt = getOptionValue(option);
    return selected === opt;
  };

  const createTokenName = () => {
    const optionsString = JSON.stringify(
      options.map(opt => (optionIsString(opt) ? opt : opt.label))
    );

    return optionsString
      .toLowerCase()
      .replace(/["[,.\] ]/g, '')
      .split('')
      .reverse()
      .join('');
  };

  useEffect(() => {
    onChange(selected);
  }, [selected]);

  return (
    <>
      {title && <h4 style={{ marginBottom: 12 }}>{title}</h4>}
      {options.map(option => (
        <div key={uuidv4()}>
          <Input
            {...rest}
            type='radio'
            id={uuidv4()}
            name={createTokenName()}
            label={getOptionLabel(option)}
            disabled={optionIsString(option) ? false : option.disabled}
            checked={checkIfIsChecked(option)}
            onChange={e => handleChecked(option)}
          />
        </div>
      ))}
    </>
  );
};

RadioGroup.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string,
        disabled: PropTypes.bool
      })
    ])
  ),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  onChange: PropTypes.func
};

RadioGroup.defaultProps = {
  title: '',
  options: [],
  onChange: () => undefined
};

export default RadioGroup;
